import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function SkpCTA() {
  return <section className="bg-navy text-white py-20 lg:py-28" data-id="element-1931" data-mp="1dpsqb2b9t3na">
      <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1932" data-mp="1iqgj9tj27uk5">
        <h2 className="font-heading font-bold text-4xl lg:text-5xl tracking-tight mb-6" data-id="element-1933" data-mp="1niqftseojsve">
          Build with SyNeural
        </h2>
        <p className="text-xl text-white/80 leading-relaxed mb-10" data-id="element-1934" data-mp="1rlmpgtm8sen7">
          Explore a research knowledge platform, discuss an NCJI integration, or
          design a governed semantic workflow for your institution.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1935" data-mp="26gj53rwds4ab">
          <a href="#contact" className="inline-flex items-center justify-center gap-2 bg-white text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1936" data-mp="26egilhufstac">
            Request a Demo
            <ArrowRight size={18} data-id="element-1937" data-mp="2h316wxp2vu12" />
          </a>
          <a href="#partnerships" className="inline-flex items-center justify-center border border-white/40 text-white hover:bg-white/10 font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1938" data-mp="2cahtq1uaz0ws">
            Explore a Partnership
          </a>
        </div>
      </motion.div>
    </section>;
}